export const MEMBERSHIP_MEMBER_MAPPINGS_RESET_STATE = 'MEMBERSHIP_MEMBER_MAPPINGS_RESET_STATE';
export const MEMBERSHIP_MEMBER_MAPPINGS_CURRENT_ITEM = 'MEMBERSHIP_MEMBER_MAPPINGS_CURRENT_ITEM';
 
export const MEMBERSHIP_MEMBER_MAPPINGS_REQUEST_LOADING = 'MEMBERSHIP_MEMBER_MAPPINGS_REQUEST_LOADING';
export const MEMBERSHIP_MEMBER_MAPPINGS_REQUEST_SUCCESS = 'MEMBERSHIP_MEMBER_MAPPINGS_REQUEST_SUCCESS';
export const MEMBERSHIP_MEMBER_MAPPINGS_REQUEST_FAILED = 'MEMBERSHIP_MEMBER_MAPPINGS_REQUEST_FAILED';
 
export const MEMBERSHIP_MEMBER_MAPPINGS_CURRENT_ACTION = 'MEMBERSHIP_MEMBER_MAPPINGS_CURRENT_ACTION';
export const MEMBERSHIP_MEMBER_MAPPINGS_RESET_ACTION = 'MEMBERSHIP_MEMBER_MAPPINGS_RESET_ACTION';